var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.0947 7h-4.979c-0.44182 0-0.8 0.35817-0.8 0.8v1.7784c0 0.44186 0.35818 0.80002 0.80001 0.80002h4.9789c0.44182 0 0.8-0.35816 0.8-0.80002v-1.7784c0-0.44182-0.35818-0.8-0.8-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.0947 11.73h-6.2947c-0.44183 0-0.8 0.35816-0.8 0.8v1.7783c0 0.44184 0.35817 0.8 0.8 0.8h6.2947c0.44183 0 0.8-0.35816 0.8-0.8v-1.7783c0-0.44184-0.35817-0.8-0.8-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.0947 16.459h-6.2947c-0.44183 0-0.8 0.35816-0.8 0.8v1.7784c0 0.44184 0.35817 0.8 0.8 0.8h6.2947c0.44183 0 0.8-0.35816 0.8-0.8v-1.7784c0-0.44184-0.35817-0.8-0.8-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.432 10.649h3.6631c0.44184 0 0.8-0.35816 0.8-0.8v-1.1027c0-0.44183-0.35816-0.8-0.8-0.8h-3.6631c-0.44184 0-0.8 0.35817-0.8 0.79999v1.1027c0 0.44184 0.35816 0.8 0.8 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.432 14.432h5.7684c0.44184 0 0.8-0.35816 0.8-0.8v-1.1026c0-0.44184-0.35816-0.8-0.8-0.8h-5.7684c-0.44184 0-0.8 0.35816-0.8 0.8v1.1026c0 0.44184 0.35816 0.8 0.8 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.432 18.216h1.0315c0.44184 0 0.8-0.35816 0.8-0.8v-1.1027c0-0.44184-0.35816-0.8-0.8-0.8h-1.0315c-0.44184 0-0.8 0.35816-0.8 0.8v1.1027c0 0.44184 0.35816 0.8 0.8 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.116 18.216h1.5579c0.44184 0 0.8-0.35816 0.8-0.8v-1.1027c0-0.44184-0.35816-0.8-0.8-0.8h-1.5579c-0.44184 0-0.8 0.35816-0.8 0.8v1.1027c0 0.44184 0.35816 0.8 0.8 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.779 4.7027h-0.50528c-0.44184 0-0.8 0.35818-0.8 0.8v15.697c0 0.44184 0.35816 0.8 0.8 0.8h0.50528c0.44184 0 0.8-0.35816 0.8-0.8v-15.697c0-0.44182-0.35816-0.8-0.8-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.505 4.1622-2.084-2.1622h4.2106z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileProject);
export default __webpack_public_path__ + "static/media/file-project.93431270.svg";
export { ForwardRef as ReactComponent };